/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import AddressForm from '../../components/Forms/AddressForm';
import BrandForm from '../../components/Forms/BrandForm';
import ContactForm from '../../components/Forms/ContactForm';
import OnboardNewClient from '../../components/onboardNewClient';
import './newClient.scss';
import useStudios, { useListingStudios } from '../../hooks/useStudios';
import { useAddCompany, useUpdateCompanies } from '../../hooks/useCompanies';
import useCountryCodes from '../../hooks/useCountryCodes';
import { Button, notification } from 'antd';
import { toast } from 'react-toastify';
import { ToasterContext } from '../../context/toasterContext';
import useLogout from '../../hooks/useLogout';
import arrowLeft from '../../../src/assets/images/arrowLeft.png';

const NewClient = props => {
    const [address, setAddresses] = useState([]);
    const [toast, setToast] = useState(false);
    const [api, contextHolder] = notification.useNotification();
    const navigate = useNavigate();
    const [contacts, setContacts] = useState([]);
    const [brands, setBrands] = useState([]);
    const [modalFlag, setModalFlag] = useState({
        type: '',
        isOpen: false,
    });
    const { toastFlag } = useContext(ToasterContext);
    const [editFmsConfig, setEditFmsConfig] = useState(null);
    const { logout } = useLogout();

    const [toasterShow, setToasterShow] = toastFlag;

    useEffect(() => {
        if (props?.editAddress) {
            setAddresses(props?.editAddress);
            setBrands(props?.editBrand);
            setContacts(props?.editContact);
            setEditFmsConfig(props?.editFmsConfig);
        }
    }, [props.editBrand, props.editAddress, props.editContact, props.companyId, props?.editFmsConfig]);

    const onSuccess = async data => {
        if (props?.companyId) {
            props.setCompanyId('');
            await props.getFetchAllCompanies();
            props.setLocalToaster(true);
        }
        navigate('/allClients');
        setToasterShow(true);
    };

    const onErrorCompany = data => {
        api.warning({
            message: `Warning!`,
            description: 'Oops! Something is wrong!',
            placement: 'topRight',
        });
    };

    const transform = data => {
        return data.map(item => {
            return {
                name: item.name,
                id: item._id,
            };
        });
    };

    // const {
    //   data: studios,
    //   isLoading,
    //   isError,
    //   error,
    // } = useStudios(null, transform);

    const { data: studioList, isError } = useListingStudios(null, transform);
    const { data: countryCodes } = useCountryCodes();
    const [selectedCountry, setSelectedCountry] = useState({
        countryName: '',
        countryCodes: [],
    });
    const [selectedCountryCode, setSelectedCountryCode] = useState();
    const {
        mutate: addCompany,
        isLoading: addCompanyLoading,
        isError: addCompanyError,
        error: addCompanyErrorData,
    } = useAddCompany(onSuccess, onErrorCompany);
    const { mutate: updateCompany } = useUpdateCompanies(onSuccess);

    const ModalHandler = data => {
        setModalFlag({
            type: data,
            isOpen: true,
        });
    };
    const CloseModal = () => setModalFlag({ type: '', isOpen: false });
    const addAddress = data => {
        // debugger
        let temp = {
            id: uuidv4(),
            contactPerson: {
                name: data.contactPerson?.trim(),
                phoneNumber: {
                    countryCode: selectedCountryCode[0],
                    phoneNumber: data.phone?.trim(),
                },
                email: data.email?.trim(),
                designation: data.designation?.trim(),
            },
            country: data.country,
            zipCode: data.zipcode?.trim(),
            city: data.city?.trim(),
            stateOrProvince: data.state?.trim(),
            addressLine1: data.addressOne?.trim(),
            addressLine2: data.addressTwo?.trim(),
            alias: data.saveAddress?.trim(),
        };
        setAddresses([...address, temp]);
        CloseModal();
    };
    const removeData = data => {
        if (data.type === 'address') {
            let temp = address.filter(item => item.id !== data.id);
            setAddresses(temp);
        } else if (data.type === 'contact') {
            let temp = contacts.filter(item => item.id !== data.id);
            setContacts(temp);
        } else if (data.type === 'brand') {
            let temp = brands.filter(item => item.id !== data.id);
            setBrands(temp);
        }
    };

    const addContact = data => {
        // debugger
        let temp = {
            id: uuidv4(),
            name: data.contactPerson?.trim(),
            phoneNumber: {
                countryCode: selectedCountryCode[0],
                phoneNumber: data.phone?.trim(),
            },
            alternatePhoneNumber: {
                countryCode: selectedCountryCode[0],
                phoneNumber: data.alternativeNumber?.trim(),
            },
            email: data.email?.trim(),
            designation: data.designation?.trim(),
        };
        setContacts([...contacts, temp]);
        CloseModal();
    };

    const addBrand = data => {
        let temp = {
            id: uuidv4(),
            name: data.brandName?.trim(),
            code: data.brandCode?.trim(),
        };
        setBrands([...brands, temp]);
        CloseModal();
    };

    const addNew = data => {
        let temp = {
            name: data.name.trim(),
            code: data.code.trim(),
            preferredStudios: [data.studio],
            addresses: address,
            contactDetails: contacts,
            brands: brands,
            lastBatchNo: data?.lastBatchNo ? parseInt(data?.lastBatchNo) : 0,
            fmsConfigOptions: data?.fmsConfigOptions ?? {},
        };

        addCompany(temp);
    };

    const updateCompanyDetails = data => {
        const oldBrandIds = props.editBrand.map(brand => brand._id);
        const filteredBrands = brands.filter(brand => !oldBrandIds.includes(brand._id));
        const oldAddressIds = props.editAddress.map(brand => brand._id);
        const filteredAddress = address.filter(brand => !oldAddressIds.includes(brand._id));
        const oldContactIds = props.editContact.map(brand => brand._id);
        const filteredContact = contacts.filter(brand => !oldContactIds.includes(brand._id));
        const filteredStudio = studioList.filter(item => item.name === data.studio);
        let finalPreferStudion = filteredStudio.length === 0 ? [data.studio] : [filteredStudio[0].id];
        let tempData = {
            addresses: filteredAddress,
            contactDetails: filteredContact,
            preferredStudios: finalPreferStudion,
            brands: filteredBrands,
            fmsConfigOptions: data?.fmsConfigOptions ?? null,
        };
        updateCompany([props.companyId, tempData]);
    };

    const onCountryChange = countryName => {
        if (countryName) {
            const country = countryCodes.find(item => item.countryName === countryName);
            setSelectedCountry(country);
            setSelectedCountryCode(country.countryCodes);
        }
    };

    if (isError) {
        logout();
    }

    return (
        <>
            {contextHolder}
            <img
                src={arrowLeft}
                alt=""
                style={{
                    width: '30px',
                    cursor: 'pointer',
                    margin: '5px',
                    // padding: "10px",
                }}
                onClick={() => navigate(-1)}
            />
            <div className="newClient-page" style={{ marginTop: '60px' }}>
                <h2 className="mb-2">Onboard a New Client</h2>
                {/* <Button onClick={() =>}>set</Button> */}
                <OnboardNewClient
                    onFinish={props?.companyId ? updateCompanyDetails : addNew}
                    studios={studioList}
                    addresses={address}
                    contacts={contacts}
                    brands={brands}
                    ModalHandler={ModalHandler}
                    companyId={props?.companyId}
                    name={props?.name}
                    code={props?.code}
                    lastBatchNo={props?.lastBatchNo}
                    preferName={props.preferStudioName}
                    setEditFormFlag={props.setEditFormFlag}
                    editFmsConfig={editFmsConfig}
                />
                {modalFlag.isOpen && (
                    <>
                        {' '}
                        <DynamicModal
                            open={modalFlag.type == 'address' && modalFlag.isOpen}
                            close={CloseModal}
                            closable
                            component={
                                <AddressForm
                                    onFinish={addAddress}
                                    setmodalContent={CloseModal}
                                    countries={countryCodes.map(country => country?.countryName)}
                                    phoneNumberPrefixes={selectedCountry?.countryCodes}
                                    onCountryChange={onCountryChange}
                                    countryCodes={countryCodes}
                                    setSelectedCountry={setSelectedCountry}
                                />
                            }
                        />
                        <DynamicModal
                            open={modalFlag.type == 'contact' && modalFlag.isOpen}
                            close={CloseModal}
                            closable
                            component={
                                <ContactForm
                                    onFinish={addContact}
                                    setmodalContent={CloseModal}
                                    phoneNumberPrefixes={props.phoneNumberPrefix ? [props.phoneNumberPrefix] : selectedCountry?.countryCodes}
                                    // phoneNumberPrefixes={selectedCountry?.countryCodes}
                                    onCountryChange={onCountryChange}
                                    countryCodes={countryCodes}
                                    setSelectedCountry={setSelectedCountry}
                                />
                            }
                        />
                        <DynamicModal
                            open={modalFlag.type == 'brand' && modalFlag.isOpen}
                            close={CloseModal}
                            closable
                            component={<BrandForm onFinish={addBrand} setmodalContent={CloseModal} />}
                        />
                    </>
                )}
                {/* {contextHolder} */}
            </div>
        </>
    );
};

export default NewClient;
